import React from "react";
import LegacyAuthProvider from "./legacy-auth";
import KeycloakProvider from "./keycloak-auth";
export type AuthProviderProps = React.PropsWithChildren<{
  /**
   * Delay between two token validity checks in ms.
   * Note that [4 ms is the minimum for HTML5](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout#Reasons_for_delays_longer_than_specified).
   * (default to `4` ms)
   */
  checkTokenValidityDelay?: number;
}>;

function AuthProvider(props: AuthProviderProps) {
  const authMethod = process.env.REACT_APP_AUTH_METHOD;

  if (authMethod === "KEYCLOAK") {
    return <KeycloakProvider>{props.children}</KeycloakProvider>;
  }
  return <LegacyAuthProvider>{props.children}</LegacyAuthProvider>;
}

export default AuthProvider;
